
define('modules/application/wizard/steps/zoneStep/complexZoneStep/zoneMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zoneMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  zoneMenuView) {

  var complexZonesMenuView = zoneMenuView.extend({
    initialize               : function()   {
      this.options.stepEventAggregator.unbind("order:changed",  this.render);
      this.options.stepEventAggregator.bind("order:changed",    this.render,         this);

      this.model.bind("name:changed",                           this.render,         this);

      this.model.unbind("zone:valid",                           this.render);
      this.model.bind("zone:valid",                             this.render,         this);

      this.model.unbind("zone:invalid",                         this.render);
      this.model.bind("zone:invalid",                           this.render,         this);
    },
    setAsLocked              : function()   {
      this.$el.addClass("locked");
    }
  });

  //Creating final complexZoneStep class
  complexZonesMenuView.extend({
    objClass      : "complexZonesMenuView"
  });

  // Required, return the module for AMD compliance
  return complexZonesMenuView;

});